import React, { useEffect, useState } from "react";
import { CButton, CModal, CModalBody, CModalFooter } from "@coreui/react";
import { useSelector } from "react-redux";
import Preview from "../ubi/Preview";
import ApiHelper from "src/utils/api/api_helper";

const PreviewPop = (props) => {
  const state = useSelector((state) => state);
  const appUrl = `${process.env.REACT_APP_API_HOST}`;

  // 미리보기
  const [preview, setPreview] = useState({
    isShow: false,
    jrffile: "",
    arg: "",
    ds: {},
    corpNm: "",
    formCatCd: "",
    layoutCd: "",
    fileName: "",
  });

  useEffect(() => {
    let params = {
      reqNo: state.insert.reqTaskInfo.reqNo,
      formNo: props.form.FORM_NO,
      formCatCd: props.form.FORM_CAT_CD,
    };
    const date = new Date();
    const year = String(date.getFullYear());
    const month =
      date.getMonth() + 1 < 10
        ? 0 + String(date.getMonth() + 1)
        : String(date.getMonth() + 1);
    const day =
      date.getDate() < 10 ? 0 + String(date.getDate()) : String(date.getDate());
    const today = year + month + day;

    const getUseCmplFormData = async () => {
      await ApiHelper.request(
        ApiHelper.methods.post,
        "/cust/request/getUseCmplFormData",
        params
      )
        .then(({ data }) => {
          if (data.status === "SUCCESS") {
            let formResult = data.data.form[0];
            let hdwtResult = data.data.hdwt;
            let sbmsResult = data.data.sbms;
            let sbmsCntList = data.data.sbmsCntInfo;
            let dsFileList = [];
            
            for (let item of sbmsCntList) {
              let i = 1;
              for (let item2 of sbmsResult) {
                if (item.SBMS_DOC_NO === item2.SBMS_DOC_NO) {
                  if (item.CNT === 1) {
                    dsFileList.push({
                      TITLE: item2.SBMS_DOC_NM,
                      FILE: item2.MID_PATH == null?  `${appUrl}cust/request/getImages/sbmsDoc?${item2.REAL_FILE_NM}` : `${appUrl}cust/request/getImages/fileDoc?${item2.MID_PATH}sbmsDoc/${item2.REAL_FILE_NM}`,
                    });
                  } else {
                    dsFileList.push({
                      TITLE: `${item2.SBMS_DOC_NM} (${i}/${item.CNT})`,
                      FILE: item2.MID_PATH == null?  `${appUrl}cust/request/getImages/sbmsDoc?${item2.REAL_FILE_NM}` : `${appUrl}cust/request/getImages/fileDoc?${item2.MID_PATH}sbmsDoc/${item2.REAL_FILE_NM}`,
                    });
                    i++;
                  }
                }
              }
            }

            let dsData = {
              ds_info: [
                {
                  SBMS_DT: today,
                  NAME: formResult.NAME,
                  BDT: formResult.BDT,
                  SEX: formResult.SEX,
                  HPHN_NO: formResult.HPHN_NO,
                  RES_REG_NO: formResult.RES_REG_NO,
                  EMAL: formResult.EMAL,
                  ADDR: formResult.ADDR,
                  BANK_NM: formResult.BANK_NM,
                  ACT_NO: formResult.ACT_NO,
                  RECR_NM: formResult.RECR_NM,
                  RECR_OFLV: formResult.RECR_OFLV,
                  RECR_EMP_NO: formResult.RECR_EMP_NO,
                  RECR_TEL: formResult.RECR_TEL_NO,
                  GRP_NM: formResult.GRP_BR_NM,
                  BR_NM: formResult.BR_NM,
                  ID_COPY:
                    formResult.REAL_FILE_NM != null
                      ? (sbmsResult.MID_PATH == null ? `${appUrl}cust/request/getImages/sbmsDoc?${formResult.REAL_FILE_NM}` : `${appUrl}cust/request/getImages/sbmsDoc?${sbmsResult.MID_PATH}sbmsDoc/${formResult.REAL_FILE_NM}`)
                      : "",
                  HDWT01: hdwtResult[0] ? hdwtResult[0].IMG_DATA : "", 
                  HDWT02: hdwtResult[1] ? hdwtResult[1].IMG_DATA : "", 
                  HDWT03: hdwtResult[2] ? hdwtResult[2].IMG_DATA : "",
                  HDWT04: hdwtResult[3] ? hdwtResult[3].IMG_DATA : "",
                  HDWT05: hdwtResult[4] ? hdwtResult[4].IMG_DATA : "",
                  HDWT06: hdwtResult[5] ? hdwtResult[5].IMG_DATA : "",
                  HDWT07: hdwtResult[6] ? hdwtResult[6].IMG_DATA : "",
                  HDWT08: hdwtResult[7] ? hdwtResult[7].IMG_DATA : "",
                  HDWT09: hdwtResult[8] ? hdwtResult[8].IMG_DATA : "",
                  HDWT10: hdwtResult[9] ? hdwtResult[9].IMG_DATA : "",
                  HDWT11: hdwtResult[10] ? hdwtResult[10].IMG_DATA : "",
                  HDWT12: hdwtResult[11] ? hdwtResult[11].IMG_DATA : "",
                  HDWT13: hdwtResult[12] ? hdwtResult[12].IMG_DATA : "",
                  HDWT14: hdwtResult[13] ? hdwtResult[13].IMG_DATA : "",
                  HDWT15: hdwtResult[14] ? hdwtResult[14].IMG_DATA : "",
                  HDWT16: hdwtResult[15] ? hdwtResult[15].IMG_DATA : "",
                  HDWT17: hdwtResult[16] ? hdwtResult[16].IMG_DATA : "",
                  HDWT18: hdwtResult[17] ? hdwtResult[17].IMG_DATA : "",
                  HDWT19: hdwtResult[18] ? hdwtResult[18].IMG_DATA : "",
                  HDWT20: hdwtResult[19] ? hdwtResult[19].IMG_DATA : "",
                  FIN_ACDNT_YN: formResult.FIN_ACDNT_YN,
                  FIN_ACDNT_CORP_NM: formResult.FIN_ACDNT_CORP_NM,
                  FIN_ACDNT_KIND: formResult.FIN_ACDNT_KIND,
                  ACDNT_DTM: formResult.ACDNT_DTM,
                  ACDNT_CTNT: formResult.ACDNT_CTNT,
                  ACDNT_DTL_CTNT: formResult.ACDNT_DTL_CTNT,
                  DISS_FIN_YN: formResult.DISS_FIN_YN,
                  DISS_CORP_NM: formResult.DISS_CORP_NM,
                  DISS_FIN_ACDNT_KIND: formResult.DISS_FIN_ACDNT_KIND,
                  DISS_DTM: formResult.DISS_DTM,
                  DISS_DTL_CTNT: formResult.DISS_DTL_CTNT,
                  ISNC_NUM: "",
                  AGREE_YN: formResult.AGREE_YN,
                  EDU_LEVEL: formResult.EDU_LEVEL,
                },
              ],
              ds_file: dsFileList,
            };

            setPreview({
              isShow: true,
              jrffile: props.form.FORM_FILE_NM,
              arg: "",
              ds: dsData,
              corpNm: state.main.corpNm,
              formCatCd: props.form.FORM_CAT_CD,
              layoutCd: props.form.VAR_INFO,
              filename: `${props.form.FORM_NM}_미리보기`,
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };

    getUseCmplFormData();
  }, []);

  return (
    <>
      <CModal
        show={preview.isShow}
        size="lg"
        closeOnBackdrop={false}
        onClosed={() => {
          props.onClose();
        }}
      >
        <CModalBody>
          {preview.isShow && (
            <Preview
              jrffile={preview.jrffile}
              arg={preview.arg}
              ds={preview.ds}
              corpNm={preview.corpNm}
              formCatCd={preview.formCatCd}
              layoutCd={preview.layoutCd}
              filename={preview.filename}
            ></Preview>
          )}
        </CModalBody>
        <CModalFooter>
          <div className="layout-footer">
            <button className="btn-footer" type="button" 
            onClick={() => setPreview({ isShow: false })}
            >
              닫기
            </button>
          </div>
          {/* <CButton
            color="secondary"
            onClick={() => setPreview({ isShow: false })}
          >
            닫기
          </CButton> */}
        </CModalFooter>
      </CModal>
    </>
  );
};

export default PreviewPop;
